<style lang="less">
	#toolbox{
		background-color: #E5E5E5;
		border-radius: 12px;
		text-align: center;
		padding: 12px;
	}
</style>

<template>
	<div v-if="elements.length">
	<p class="overline">Visibility Conditions</p>
	<v-row>
		<v-col cols="12" md="2" lg="1">
			<div id="toolbox">
				<v-menu offset-x>
					<template v-slot:activator="{ on }">
						<v-btn icon class="mr-1 mt-1" v-on="on" color="primary"><v-icon>mdi-frequently-asked-questions</v-icon></v-btn>
					</template>
					<v-list>
						<v-list-item v-for="question in elements" :key="question.name" @click="insertQuestion(question)">
							<v-list-item-title>{{ question.title }}</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
				<v-btn icon class="ml-1 mr-1 mt-1" color="primary" v-on:click="insertText(false)"><v-icon>mdi-text-short</v-icon></v-btn>
				<v-divider></v-divider>
				<InsertOperator v-on:insert="insert"></InsertOperator>
			</div>
		</v-col>
		<v-col cols="12"  md="10" lg="11">
			<v-tabs v-model="tab" right>
				<v-tab key="visual">
					Visual
				</v-tab>
					<v-tab-item>
						<div v-on:mouseover="active = true" v-on:mouseleave="active = false" class="mt-3">
							<v-alert  style="min-height: 60px"  text color="info">
								<v-chip 
								v-for="(condition, index) in conditions" 
								:key="index" class="ma-2" 
								@click="position = index" 
								:color="position == index ? 'primary' : 'light'" 
								v-on:click.right="deleteCondition(index)"> 
									<span v-if="condition.displayText">
										{{condition.displayText}}
									</span> 
									<span v-else>
										{{condition.content}}
									</span>
									<span v-if="condition.split && position == index">
										<v-icon class="ml-2" @click="editConditionDialog = 1; editCondition = condition">mdi-arrow-down-drop-circle</v-icon>
									</span>
								</v-chip>
							</v-alert>
						</div>
					</v-tab-item>
				<v-tab key="text">
					Text
				</v-tab>
					<v-tab-item>
						<v-textarea outlined class="mt-3" v-model="editConditionString"></v-textarea>
					</v-tab-item>
			</v-tabs>
			<p class="text-right"><v-btn color="primary" @click="save">Save Conditions</v-btn></p>
			<v-dialog v-model="editConditionDialog" max-width="400px">
				<v-card>
					<v-card-text class="mt-2">
						<div v-if="editCondition.type == 'text'">
							<v-text-field v-model="editCondition.content"></v-text-field>
						</div>

						<div class="pt-4" v-if="editCondition.subquestions">
							<p class="overline">Subquestions</p>
							<v-chip class="ml-2 mt-2" v-for="(subquestion, index) in editCondition.subquestions" :key="index" @click="insertSubquestion(editCondition, subquestion)">{{subquestion.text}}</v-chip>
							
							<v-divider class="ma-4"></v-divider>
						</div>
						<div class="pt-4" v-if="editCondition.type == 'options'">
							<p class="overline">Operator</p>
							<p text-align="justify">
								<InsertOperator v-on:insert="insert"></InsertOperator>
							</p>
							<p class="overline">Options</p>
								<v-divider class="ma-4"></v-divider>
								<v-chip class="ml-2 mt-2" v-for="(option, index) in editCondition.options" :key="index" @click="insertAnswerOption(option)">
									{{option.text}}
								</v-chip>
						</div>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="accent darken-1" text @click="editConditionDialog = false" >Done</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-col>
	</v-row>
	</div>
</template>
<script>
	import InsertOperator from "../editorFields/InsertOperator.vue";

	export default {
		name: "VisibleIf",
		components: {
			InsertOperator: InsertOperator
		},
		data: () => {
			return {
				tab: 'visual',
				conditions: [],
				position: 0, 
				active: false,
				editConditionDialog: false,
				editCondition: false, 
				conditionString: '',
				editConditionString: ''
			}
		},
		props: {
			elements: { type: Array },
			question: { type: Object }
		},
		methods:{
			insert(content){
				this.conditions.splice( this.position+1, 0, content )
				this.position++;
			},
			insertQuestion(question, subquestion = false){
				let content = {
					question: question.name,
					content: "{" + question.name + "}", 
					displayText: question.title,
				}
				if( question.rows ){
					content.split = true;
					content.type = "options";
					content.subquestions = question.rows;
				}
				if( question.choices ){
					content.split = true;
					content.type = "options";
					content.options = question.choices;
				}
				if( question.columns ){
					content.split = true;
					content.type = "options";
					content.options = question.columns;
				}
				if( subquestion ){
					this.insertSubquestion( content, subquestion)
				}
				this.insert( content )
			},
			insertSubquestion(condition, subquestion){
				condition.content = "{" + condition.question + "." + subquestion.value + "}"
				condition.displayText = condition.displayText + " - " + subquestion.text;
			},
			insertAnswerOption(option){
				if( !option ){ return; }				
				this.insert( { type: "text", content: option.value, displayText: option.text } )
			},
			deleteCondition(i){
				const self = this;
				event.preventDefault();
				setTimeout(function() {				
					self.conditions.splice( i, 1 )
					if( self.position > self.conditions.length ){
						self.position = self.conditions.length;
					}
				}, 10);
			},
			save(){
				if( typeof this.editConditionString !== 'undefined'){
					this.$emit("save", this.editConditionString, this.question)
				}
				this.getConditionsFromString();
				this.active = false;
			},
			insertText(text, displayText){
				if( !text ){ text = "..."; }
				let condition =  { split: true, type: 'text', content: text };
				if( displayText ){
					condition.displayText = displayText;
				}
				this.insert( condition )
			},	
			getConditionsFromString(){
				const self = this; 
				self.conditions = [];
				if( !self.editConditionString ){ return; }
				let conditionParts = self.editConditionString.split(" ");
				let operators = ["=", "!", "!=", "and", "(", ")", ">", ">=", "<", "<=", "or", "anyof", "contains", "notcontains", "[", "]", ","];
				self.position = 0;
				let availableChoices = {};
				conditionParts.forEach( function(c){
					if( c != "" ){

						if( operators.indexOf(c) > -1 ){
							let condition = {content: c};
							self.conditions.push( condition );
							self.position++;
						}
						else if( c.substr(0,1) == "{" ){
							let questionId = c.substr(1, c.length - 2);
							let question = self.elements.find( e => e.name == questionId );
							let subquestion = false;
							if( !question ){
								let splitId = questionId.split(".")
								question = self.elements.find( e => e.name == splitId[0] );
								subquestion = question.rows.find( a => a.value == splitId[1]);
							}
							if( question.choices  ){
								availableChoices = {};
								question.choices.forEach( c => availableChoices[c.value] = c.text )
							}
							if( question.columns  ){
								availableChoices = {};
								question.columns.forEach( c => availableChoices[c.value] = c.text )
							}
							if( subquestion ){
								self.insertQuestion( question, subquestion )
							}
							else{
								self.insertQuestion( question );
							}

						}
						else{
							c = c.replace(/'/g,'');
							if( availableChoices[c] ){
								self.insertText( c, availableChoices[c] )
							}
							else{
								self.insertText( c)
							}
						}
					}
				})
			}
		},
		watch: {
			conditions: {
				handler: function(){
					const self = this;
					self.conditionString = "";
					self.conditions.forEach( function(c){
						
						if( c.type == 'text'  && isNaN(c.content) ){
							self.conditionString += "'" + c.content + "'";
						}
						else{
							self.conditionString += c.content;
						}
						self.conditionString += " ";
						self.editConditionString = self.conditionString;
					} )			
				},
				deep: true
			}, 
		},
		created: function(){
			this.editConditionString = this.question.visibleIf;
			this.getConditionsFromString();
		},
	}

</script>